import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  private baseUrl: string;
  private sasToken: string;

  constructor(private http: HttpClient, private configService: ConfigService, private toastService: ToastService) {
    this.baseUrl = this.configService.pessoaApi;
    this.sasToken = 'sv=2022-10-07&se=2025-01-09T12%3A00%3A00Z&sr=b&sp=r&sig=abcdefg1234567890';
  }

  getDocumentVinculatedContract(contract_id: any,
    pageIndex: any,
    sortProperty: any,
    sortDirection: any,

    nomeTipoDocumento?: any,
    descricao?: any,
    dataCriacaoInical?: any,
    dataCriacaoFinal?: any,
    usuarioCriacao?: any,

  ) {
    const params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', '10')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('nomeTipoDocumento', nomeTipoDocumento || '')
      .set('descricao', descricao || '')


    return this.http.get(this.baseUrl + `/v1/contratos/${contract_id}/documentos`, { params })
  }

  createDocumentVinculatedContract(contract_id: any, data: any, cnpj: any) {
    const formData = new FormData();
    const cpfSemFormatacao = cnpj?.cnpj ? cnpj?.cnpj.replace(/\D/g, '') : '';

    formData.append('idTipoDocumento', data.idTipoDocumento);
    formData.append('descricao', data.descricao);
    formData.append('nomeArquivo', data?.anexo.name);
    formData.append('subCategoria', cpfSemFormatacao);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('objetoOriginal', data?.anexo.file);
    const fileExtension = data.anexo.type.split('/')[1];
    formData.append('tipoMime', fileExtension);


    // Faça a requisição POST usando FormData
    return this.http.post(this.baseUrl + `/v1/contratos/${contract_id}/documentos`, formData);
  }

  updatedDocumentVinculatedContract(contract_id: any, document_id: any, data: any, cnpj: any) {
    const cpfSemFormatacao = cnpj?.cnpj ? cnpj?.cnpj.replace(/\D/g, '') : '';
    const formData = new FormData();
    formData.append('idTipoDocumento', data.idTipoDocumento);
    formData.append('descricao', data.descricao);
    formData.append('nomeArquivo', data?.anexo ? data?.anexo.name : data.nomeArquivo);
    formData.append('subCategoria', cpfSemFormatacao);
    formData.append('categoria', 'cadastro_contrato');
    formData.append('objetoOriginal', data?.anexo, data?.anexo?.name);
    if(!data.fileChanged){
       const emptyFile = new File([], '');
      formData.set('objetoOriginal', emptyFile);
    }


    
    const fileExtension = data?.anexo ? data.anexo.type.split('/')[1] : data.tipoMime;
    formData.append('tipoMime', fileExtension);
    return this.http.put(this.baseUrl + `/v1/contratos/${contract_id}/documentos/${document_id}`, formData)
  }

  deleteDocumentVinculatedContract(contract_id: any, document_id: any) {
    return this.http.delete(this.baseUrl + `/v1/contratos/${contract_id}/documentos/${document_id}`)
  }

  listTypeDocuments() {
    return this.http.get(this.baseUrl + '/v1/tipos-documento?sortField=nome&sortDirection=asc');
  }

  toggleStatus(contractId: number, intervenienteId: number) {
    return this.http.patch(this.baseUrl + `/v1/contracts/${contractId}/intervenientes/${intervenienteId}`, {});
  }

  downloadDocument(contractID: any, document: any): any {
    const downloadUrl = `${this.baseUrl}/v1/contratos/${contractID}/documentos/${document.id}/download`;
    const urlWithSas = `${downloadUrl}?${this.sasToken}`;
    return this.http.get(urlWithSas, {
      responseType: 'blob' as 'json',
      observe: 'response',
    }); 
  }

  getHistoryDocument(contractId: string | null,  documentId: string | null, pageIndex:number = 0){
    return this.http.get(this.baseUrl + `/v1/contratos/${contractId}/documentos/${documentId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`);
  }

  convertBlobAndDownload(response: HttpResponse<Blob>) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const body = JSON.parse(reader.result as string);
        if (body.sasURL) {
          window.open(body.sasURL, '_blank');
        } else {
          this.toastService.showError('Erro: URL do arquivo não encontrada.');
        }
      } catch (err) {
        this.toastService.showError('Erro ao processar a resposta do servidor.');
      }
    };

    reader.readAsText(response.body!);
  }

  convertBlobToFile(response: HttpResponse<Blob>) {
    const contentDisposition = response.headers.get('Content-Disposition');

    let filename = 'downloaded-file';
    if (contentDisposition) {
      const matches = /filename[^;=\n]*=([^;\n]*)/.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    const blob = response.body;
    if (blob) {
      const file = new File([blob], filename, { type: blob.type });

      return file;
    }
    return null;
  }
  
  download(contractID: any, documentId: any): any {
    
    const downloadUrl = `${this.baseUrl}v1/contratos/${contractID}/documentos/${documentId}/download`;
    const urlWithSas = `${downloadUrl}?${this.sasToken}`;

    return this.http.get(urlWithSas, {
      responseType: 'blob' as 'json',
      observe: 'response',
    });
  }
  downloadFormProjeto(idProjetoServicoAmpliacao:any, idDisciplinaProjeto:any, idArquivoDisciplina:any,){
    const downloadUrl = `${this.baseUrl}/v1/projetos/servicos-ampliacao/${idProjetoServicoAmpliacao}/disciplinas/${idDisciplinaProjeto}/arquivos/${idArquivoDisciplina}/download`;
    const urlWithSas = `${downloadUrl}?${this.sasToken}`;

    return this.http.get(urlWithSas, {
      responseType: 'blob' as 'json',
      observe: 'response',
    });
  }
} 
